import { t } from '@lingui/macro';
import { apiMeta } from 'api/meta';
import { BaseColumns } from 'types/table';
import { StyleData } from 'features/purchase-orders/types';
import { Response } from 'types';
import { transformFilter } from 'utils/table';

const isStyleDataResponse = (data: unknown): data is Response<StyleData[]> =>
  typeof data === 'object' && data !== null && 'data' in data;

const toStyleNameFilterOptions = (data: unknown) => {
  if (!isStyleDataResponse(data) || !data.data) return [];

  return data.data
    .filter(item => item.id)
    .map(d => ({
      id: String(d.id),
      label: String(d.styleName),
    }));
};

const toStyleNumberFilterOptions = (data: unknown) => {
  if (!isStyleDataResponse(data) || !data.data) return [];

  return data.data
    .filter(d => d.styleNumber && d.styleNumber.trim() !== '' && d.id)
    .map(d => ({
      id: String(d.id),
      label: String(d.styleNumber),
    }));
};

const apiFilters = (field: string) => ({
  url: apiMeta.get.filtersStylesForPoMapping,
  key: 'metaFiltersPOProductCertificates',
  revalidate: true,
  responseTransform: (data: unknown) => transformFilter(data, field),
});

export const cols: BaseColumns = {
  styleName: {
    id: 'styleName',
    label: t`Style name`,
    type: 'dd',
    api: {
      url: apiMeta.get.filtersStylesNameSearchSupplierCertificates,
      key: 'metaFiltersPOProductCertificatesStyleNameSearch',
      search: true,
      options: { enabled: true },
      responseTransform: toStyleNameFilterOptions,
    },
  },
  styleNumber: {
    id: 'styleNumber',
    label: t`Style number`,
    type: 'dd',
    api: {
      url: apiMeta.get.filtersStylesNumberSearchSupplierCertificates,
      key: 'metaFiltersPOProductCertificatesStyleNumberSearch',
      search: true,
      options: { enabled: true },
      responseTransform: toStyleNumberFilterOptions,
    },
  },
  color: { id: 'stylecolorname', label: t`Color variants`, type: 'text' },
  group: { id: 'group', label: t`Group`, type: 'dd', api: apiFilters('group') },
  categories: {
    id: 'categories',
    label: t`Category`,
    type: 'dd',
    api: apiFilters('category'),
  },
};
